export default __webpack_public_path__ + "static/media/image2.91a95f20.png";